import Clarity from "@microsoft/clarity";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from "../../project_config";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import Header from "../common/header/Header";

const CONTACT_PHONE_DISPLAY = "۰۲۱-۸۸۶۹۹۲۶۵";
const CONTACT_PHONE_TEL = "+982188699265";

const CONTACT_ADDRESS =
	"استان تهران، شهرستان شمیرانات، بخش مرکزی، شهر تجریش، کاشانک، خیابان شهید ابوالقاسم رضایی، خیابان پاسداران، پلاک ۵۶۵، ساختمان صاحبقرانیه، طبقه ۴، واحد ۱۰";

function ContactRow({ label, children }) {
	return (
		<div className="rounded-[12px] border border-[#E2E8F0] bg-[#F8FAFC] p-5 md:p-6 text-right">
			<p className="font-Vazir-700 text-[14px] text-[#64748B] mb-2">{label}</p>
			<div className="font-Vazir-400 text-[15px] md:text-[16px] leading-[1.9] text-darkBlue">
				{children}
			</div>
		</div>
	);
}

export default function ContactUs() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(() => window.innerWidth > 768);

	const linkDataList = [
		{ label: "خانه", href: "/" },
		{ label: "تماس با ما", href: "/contact_us/" },
	];

	return (
		<>
			<Helmet>
				<title>تماس با ما | همراهتیم</title>
				<meta
					name="description"
					content="راه‌های تماس با همراهتیم — تلفن و آدرس."
				/>
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[600px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[40px]" />
					<article
						className={`${isDesktop ? "w-[720px]" : "px-4"} mx-auto bg-white rounded-[16px] shadow-sm p-6 md:p-10`}
					>
						<h1 className="font-Vazir-800 text-[24px] md:text-[28px] text-darkBlue text-center mb-4">
							تماس با ما
						</h1>
						<p className="font-Vazir-400 text-[15px] md:text-[16px] leading-[2] text-[#64748B] text-center mb-8">
							مشتری گرامی، برای پاسخگویی و هماهنگی با تیم همراهتیم از راه‌های
							زیر استفاده کنید.
						</p>
						<div className="space-y-4">
							<ContactRow label="تلفن">
								<a
									href={`tel:${CONTACT_PHONE_TEL}`}
									className="font-Vazir-700 text-[18px] md:text-[20px] text-[#276AA6] hover:text-[#164785] transition-colors"
									dir="ltr"
								>
									{CONTACT_PHONE_DISPLAY}
								</a>
							</ContactRow>
							<ContactRow label="آدرس">
								<p>{CONTACT_ADDRESS}</p>
							</ContactRow>
						</div>
					</article>
					<div className="spacer p-[40px]" />
				</div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
